import * as THREE from 'three';
import images from './images';
const container = document.querySelector('.three_bg');
const loader = new THREE.TextureLoader();

// Create a scene
const scene = new THREE.Scene();
// Create a camera
const camera = new THREE.PerspectiveCamera(70, window.innerWidth / window.innerHeight, 0.1, 1000);
//camera.position.z = 5;
// Create a renderer
const renderer = new THREE.WebGLRenderer({ antialias: true, 
//alpha: true 
});
renderer.setSize(window.innerWidth, window.innerHeight);
container.appendChild(renderer.domElement);

//responsive
window.addEventListener('resize', () => {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
});

const geometry = new THREE.PlaneGeometry( 18, 10, 15, 9 );

const material = new THREE.MeshBasicMaterial({ 
//color: 0x00ff00, 
map: loader.load(images.bg3), 
//wireframe: true, 
});

const cube = new THREE.Mesh(geometry, material);
// Rotate the plane 90 degrees to make it a wall on the right side
//cube.rotation.y = Math.PI / 2;
// Position it on the right side
//cube.position.x = 2.5;
scene.add(cube);

camera.position.z = 5;

const count = geometry.attributes.position.count;
const clock = new THREE.Clock();
//console.log(count);

function animate() {
    // Animate the vertices
    for (let i = 0; i < count; i++) {
        const time = clock.getElapsedTime();
        const x = geometry.attributes.position.getX(i);
        const y = geometry.attributes.position.getY(i);

        //animations
        const anim1 = 0.75 * Math.sin(x * 2 + time * 0.7);
        const anim2 = 0.25 * Math.sin(x + time * 0.7);
        const anim3 = 0.1 * Math.sin(y*15 + time * 0.7);
        const anim4 =  0-.2 * Math.sin(x + time) -.2 * Math.sin(y + time);

        const wave1 = 0.5 * Math.sin(x * time * 0.5 + y);
        const wave2 = 0.3 * Math.sin(x * time * 0.8 + y * 1.5);
        const wave3 = 0.2 * Math.sin(x * time * 1.2 + y * 2);

        geometry.attributes.position.setZ(i , anim1  + anim2 + anim3);
        geometry.computeVertexNormals();

        geometry.attributes.position.needsUpdate = true; // Mark for update
    }

    requestAnimationFrame(animate);
    renderer.render(scene, camera);
}
animate();